import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

export default ({ ac, params }) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'GET',
    url: 'queries.php',
    params: { ac, ...params },
    headers: {
      token: decipher?.token?.value,
      action: ac,
    },
  })
}
